import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import tw, { styled } from "twin.macro";
import Icon from "@shared/components/Icon";

const FeedContainer = styled.div`
  ${tw`grid grid-cols-1 gap-6 w-full`}
`;

const PostCard = styled.a`
  ${tw`relative bg-white border border-gray-300 shadow-md overflow-hidden`};
  &:hover .overlay {
    ${tw`opacity-100`}
  }
`;
const PostMediaWrapper = styled.div`
  ${tw`relative`}
`;
const PostImage = styled(GatsbyImage)`
  ${tw`w-full`}
`;
const Overlay = styled.div`
  ${tw`absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center text-white text-2xl font-bold opacity-0 transition-opacity duration-300`}
`;

const PostContent = styled.div`
  ${tw`p-2 flex flex-col`}
`;

const PostCaption = styled.p`
  ${tw`text-xs text-gray-700 leading-snug truncate`}
`;

const PostMeta = styled.div`
  ${tw`flex justify-between items-center text-gray-500 text-xs mt-2`}
`;

const PostIndicator = styled.span`
  ${tw`px-2 py-1 rounded-full bg-blue-500 text-white text-[10px] uppercase`}
`;

const VideoOverlay = styled.div`
  ${tw`absolute inset-0 flex items-start justify-end pointer-events-none text-white`};
`;

const InstagramFeed = ({ data, site }) => {
  const reduceInstaNode =
    (_.get(data, "allGames.nodes.length", 0) > 1 && site === "academy") ||
    _.get(data, "allHomeGames.nodes.length", 0) > 1;
  return (
    <FeedContainer>
      {data.allInstaNode.edges.map(({ node }, idx) => {
        if (reduceInstaNode && idx === 2) {
          return null;
        }

        const image = getImage(node.localFile.childImageSharp.gatsbyImageData);
        const isVideo = node.mediaType === "GraphVideo";

        return (
          <PostCard
            key={node.id}
            href={`https://www.instagram.com/p/${node.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PostMediaWrapper>
              <PostImage image={image} alt={node.caption || "Instagram post"} />
              <Overlay className="overlay">
                {isVideo && (
                  <>
                    <Icon
                      name="smart_display"
                      style={{
                        fontSize: "24px",
                        marginRight: "8px",
                      }}
                    />
                    |{" "}
                  </>
                )}
                <Icon
                  name="favorite"
                  style={{
                    fontSize: "24px",
                    marginRight: "8px",
                    marginLeft: "8px",
                  }}
                />{" "}
                {node.likes || 0} |{" "}
                <Icon
                  name="chat"
                  style={{
                    fontSize: "24px",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                />{" "}
                {node.comments || 0}
              </Overlay>
            </PostMediaWrapper>
            {/* <PostContent>
              <PostCaption title={node.caption}>
                {node.caption || "No caption"}
              </PostCaption>
              <PostMeta>
                <PostIndicator>{isVideo ? "Video" : "Image"}</PostIndicator>
                <span>
                  {new Date(node.timestamp * 1000).toLocaleDateString(
                    undefined,
                    {
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                    }
                  )}
                </span>
              </PostMeta>
            </PostContent> */}
          </PostCard>
        );
      })}
    </FeedContainer>
  );
};

export default InstagramFeed;
